import Reveal from "./components/Reveal.jsx";
import Projects from "./components/Projects.jsx";
import Copy from "./components/Copy.jsx";
import { CO, FACTS, SERVICES, STEPS } from "./data.js";
import { go } from "./utils.js";
import './styles.css'

export default function App() {
  const nav = [["Services", "services"], ["Process", "process"], ["Projects", "projects"], ["Contact", "contact"]];
  return (
    <div id="top">
      <header className="top">
        <div className="wrap top-in">
          <a className="brand" href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0 }); }}>
            {CO.name} <small>{CO.tagline}</small>
          </a>
          <div className="top-r">
            <nav className="nav" aria-label="Main">
              {nav.map(([t, id]) => (
                <a key={id} href={"#" + id} onClick={(e) => { e.preventDefault(); go(id); }}>{t}</a>
              ))}
            </nav>
            <button type="button" className="btn btn-sm" onClick={() => go("contact")}>Book a site visit</button>
          </div>
        </div>
      </header>

      <main>
        <section className="wrap hero">
          <h1>We build the room you drew.</h1>
          <div>
            <p>Kitchens, bathrooms, and whole-home renovations, designed and built by one licensed crew from first sketch to final walkthrough.</p>
            <div className="cta-row">
              <button type="button" className="btn" onClick={() => go("contact")}>Book a site visit</button>
              <a className="link" href="#projects" onClick={(e) => { e.preventDefault(); go("projects"); }}>See recent work</a>
            </div>
          </div>
        </section>

        <Reveal />

        <ul className="wrap facts">
          {FACTS.map(([t, d]) => (
            <li key={t}><h3>{t}</h3><p>{d}</p></li>
          ))}
        </ul>

        <section className="sec" id="services">
          <div className="wrap split">
            <div>
              <h2>What we remodel</h2>
              <p className="lede">Every project starts with measured drawings and a written schedule.</p>
            </div>
            <ul className="rows">
              {SERVICES.map(([t, d, m]) => (
                <li key={t}><h3>{t}</h3><p>{d}</p><span className="meta">{m}</span></li>
              ))}
            </ul>
          </div>
        </section>

        <section className="sec alt" id="process">
          <div className="wrap split">
            <div>
              <h2>How a project runs</h2>
              <p className="lede">A typical kitchen takes about 18 weeks from first visit to walkthrough.</p>
            </div>
            <ol className="steps">
              {STEPS.map(([w, t, d]) => (
                <li key={t}><span className="wk">{w}</span><h3>{t}</h3><p>{d}</p></li>
              ))}
            </ol>
          </div>
        </section>

        <section className="sec" id="projects">
          <Projects />
        </section>

        <section className="sec band contact-sec" id="contact">
          <div className="wrap split">
            <div>
              <h2>Tell us what you want to change.</h2>
              <p className="lede">Call or write and we will set up a site visit. We reply within one business day.</p>
            </div>
            <dl className="contact-rows">
              <div className="crow">
                <dt>Phone</dt><dd id="co-phone">{CO.phone}</dd>
                <Copy text={CO.phone} targetId="co-phone" label="phone number" />
              </div>
              <div className="crow">
          <dt>Email</dt>
<dd id="co-email">
  <a href={`mailto:${CO.email}?subject=${encodeURIComponent('Website Inquiry')}`}>
    {CO.email}
  </a>
</dd>
                <div text={CO.email} targetId="co-email" label="email address" />
              </div>
              <div className="crow"><dt>Hours</dt><dd>{CO.hours}</dd></div>
              <div className="crow"><dt>Service area</dt><dd>{CO.area}</dd></div>
            </dl>
          </div>
        </section>
      </main>

      <footer className="band">
        <div className="wrap foot">© 2026 {CO.name} {CO.tagline}. Licensed, bonded, and insured.</div>
      </footer>
    </div>
  );
}
